export default "__VITE_ASSET__sd7OAvyB__"